module.exports = __webpack_public_path__ + "static/media/EventInfoImg.624bc1c6.png";